window["sharedResources"] = window["sharedResources"] || {}; window["sharedResources"] = {...window["sharedResources"], ...{
	"Add": "Add",
	"Bridge": "Bridge",
	"Bridges": "Bridge",
	"CalculationType": "Calculated",
	"Cancel": "Cancel",
	"CancelChangesAndContinue": "Continue without saving",
	"ChangeDashboard": "(change dashboard)",
	"ConfirmDelete": "Confirm deletion",
	"ConfirmDeleteContent": "Are you sure to delete {0}?",
	"Dashboard": "Dashboard",
	"Detail": "Detail",
	"Device": "Device",
	"Devices": "Devices",
	"DirectoryName": "Directory name",
	"EditTelemetries": "Telemetries",
	"EndTime": "End date",
	"Eur63Type": "Eur63",
	"ExportToExcel": "Export to Excel",
	"ExtractTelemetries": "Extract telemetries",
	"ExtractTelemetrySummaries": "Extract telemetry summaries",
	"FieldRequired": "Required field",
	"Filter": "Filter",
	"GetApiError": "The server is not responding",
	"Group": "Group",
	"Hour": "hour",
	"HowFrequently": "Repeat every (hh:mm:ss)",
	"ImplicitReadOnlyRole": "Implicit read only",
	"InvalidInterval": "Invalid interval",
	"IpAddress": "IP address",
	"Loading": "Loading...",
	"LoginTitle": "Login",
	"LostChange": "The changes have not been saved",
	"MachineState_Automatic": "Automatic",
	"MachineState_Other": "Not automatic",
	"Minute": "minute",
	"Name": "Name",
	"NavigationMenuItemBridges": "Bridge",
	"NavigationMenuItemDashboard": "Dashboard",
	"NavigationMenuItemDevices": "Devices",
	"NavigationMenuItemMasterData": "Master Data",
	"NavigationMenuItemReport": "Report",
	"NavigationMenuItemTelemetries": "Telemetries",
	"NavigationMenuItemTelemetryGroups": "Telemetry Groups",
	"Off": "off",
	"Ok": "Ok",
	"On": "on",
	"Password": "Password",
	"ReturnToEditForm": "Stay in Edit",
	"Save": "Save",
	"SaveError": "Error",
	"SaveSuccess": "Saved",
	"Second": "second",
	"SignOut": "Sign out",
	"StartTime": "Start date",
	"Tag": "Tag",
	"Telemetries": "Telemetries",
	"TelemetriesOf": "Telemetries of {0}",
	"Telemetry": "Telemetry",
	"TelemetryGroup": "Telemetry Group",
	"TelemetryGroups": "Telemetry Groups",
	"TelemetryGroupsTelemetry": "Associated telemetry",
	"ThisTiming": "This schedule",
	"Timing": "Schedule",
	"Timings": "Schedules",
	"TimingsOf": "Schedules of {0}",
	"TrackingDate": "Acquisition date",
	"Type": "Type",
	"TypeDevices": "Insert devices",
	"TypeTelemetries": "Insert telemetries",
	"Units": "Units",
	"UnSavedChange": "UnSaved changes",
	"UserName": "User name",
	"Value": "Value",
	"ProductionOrders": "Production Orders",
	"InvalidCustomer": "Invalid Customer",
	"InvalidDealer": "Invalid Dealer",
	"InvalidDevice": "Invalid Device",
	"InvalidFileName": "Invalid FileName",
	"InvalidMachine": "Invalid Machine",
	"InvalidSerialNumber": "Invalid Serial Number",
	"NavigationMenuItemMachine": "Machines",
	"NavigationMenuItemCustomer": "Customers",
	"NavigationMenuItemDataLog": "DataLog",
	"NavigationMenuItemDealer": "Dealers",
	"NavigationMenuItemSetup": "Setup",
	"NavigationMenuItemWorkPlan": "WorkPlans",
	"CollectionTime": "Acquisition Date",
	"EmptyDropDown": "(empty)",
	"UploadDocumentTitle": "New DataLog",
	"Customer": "Customer",
	"DealerName": "Dealer",
	"DocumentType": "Log type",
	"Machine": "Machine",
	"MachineDescription": "Machine",
	"IoTHub": "IoT Hub",
	"SerialNumber": "Serial Number",
	"Created": "Creation date",
	"FileName": "FileName",
	"Machines": "Machines",
	"CustomerName": "Customer",
	"Description": "Description",
	"DeviceSerialNumber": "Device Serial Number",
	"Engine": "Engine",
	"DealerDefaultName": "Insert dealer name",
	"Dealers": "Dealers",
	"DeviceDefaultDescription": "Insert device name",
	"MachineDefaultName": "Insert machine name",
	"Customers": "Customers",
	"Document": "DataLog",
	"MachineSerialNumber": "Serial Number",
	"NavigationMenuItemUser": "Users",
	"WorkPlan": "WorkPlan",
	"Yard": "JobSite",
	"ChangePassword": "Change password",
	"ConfirmNewPassword": "\"Confirm new password",
	"ForgotPassword": "Forgot password ?",
	"LogIn": "Login",
	"NewPassword": "New password",
	"OldPassword": "Old password",
	"RememberMe": "Remember me on this computer",
	"CompareAttribute": "'{0}' and '{1}' do not match.",
	"Invalid login attempt.": "Invalid Login",
	"RequiredAttribute": "{0} field is required.",
	"Role": "Position",
	"SelectAnItem": "Select an item",
	"Users": "Users",
	"DeviceAlreadyAssigned": "Device already assigned to another machine",
	"AuthorizeDocumentView": "Allow Service and Dealer to access LOG files",
	"Authorized": "Authorized",
	"Origin": "Origin",
	"StorageUrl": "Storage URL",
	"AuthorizeDocumentViewGrid": "Allow access to LOG files",
	"CreatedBy": "Created by",
	"Modified": "Modification date",
	"ModifiedBy": "Modified by",
	"AdministratorsRole": "Administrator",
	"CustomerRole": "Customer Technician",
	"DealerRole": "Dealer Technician",
	"ServiceRole": "Service Technician",
	"CustomerMandatory": "Mandatory for \"Customer\" position",
	"CustomerNotToSet": "Do not set for these positions",
	"DealerMandatory": "Mandatory for \"Dealer\" position",
	"DealerNotToSet": "Do not set for these positions",
	"InvalidRole": "Invalid position",
	"UserNameEmailAddress": "Set email address",
	"ForgotPasswordConfirmation": "Confirm forgot password",
	"ForgotPasswordConfirmationMessage": "To reset password: check email sent to your mailbox.",
	"ResetPasswordEmailMessage": "<div style=\"font: 16px Arial, sans-serif;\"> Gentile cliente,<br/> questa mail è stata generata automaticamente dal portale ComNect.<br/> <br/> La informiamo che è stata richiesta la reimpostazione della sua password di accesso al portale ComNect, per proseguire <a href=\"{0}\">clicchi qui</a><br/> <br/> Per chiarimenti contatti l'assistenza <a href=\"https://www.comacchio.com\"/>Comacchio</a><br/> <br/> <img src=\"{1}\" width=\"293\"/><br/> <br/> Dear customer,<br/> This email was automatically generated by the ComNect portal.<br/> <br/> We inform you that a request has been received to change the password to access the ComNect portal, to continue <a href=\"{0}\">click here</a><br/> <br/> For clarification, please contact us <a href=\"https://www.comacchio.com\"/>Comacchio</a><br/> <br/> <img src=\"{1}\" width=\"293\"/></div>",
	"Submit": "Submit",
	"UserProfile": "UserName/Email",
	"CreateUserMailBody": "<div style=\"font: 16px Arial, sans-serif;\"> Gentile cliente,<br/> questa mail è stata generata automaticamente dal portale ComNect.<br/> <br/> La informiamo che è stato creato un utente collegato a questo indirizzo email per accedere al portale ComNect comnect.comacchio.com.<br/> Per effettuare il primo accesso è necessario impostare la password al seguente link: <a href=\"{0}\">link</a><br/> Attenzione, la password da impostare deve soddisfare tutti i seguenti requisiti:<br/> almeno 8 caratteri;<br/> almeno una lettera maiuscola;<br/> almeno un numero;<br/> almeno un carattere speciale.<br/> <br/> Per chiarimenti contatti l'assistenza <a href=\"https://www.comacchio.com\"/>Comacchio</a><br/> <br/> <img src=\"{1}\" width=\"293\"/><br/> <br/> Dear customer,<br/> This email was automatically generated by the ComNect portal.<br/> <br/> We inform you that the user connected to this email address has been created to access the ComNect portal comnect.comacchio.com.<br/> To log in for the first time you need to set the password at the following link: <a href=\"{0}\">link</a><br/> Attention, the password to be set must meet all the following requirements:<br/> at least 8 characters;<br/> at least one capital letter;<br/> at least one number;<br/> at least one special character.<br/> <br/> For clarification, please contact us <a href=\"https://www.comacchio.com\"/>Comacchio</a><br/> <br/> <img src=\"{1}\" width=\"293\"/></div>",
	"CreateUserMailSubject": "User creation",
	"CollectionTimeDeviceLocal": "JobSite acquisition date",
	"ConfirmPassword": "Confirm password",
	"FirstAccess": "First access",
	"Set": "Set",
	"SetYourPassword": "Set your password",
	"Reset": "Reset",
	"ResetPassword": "Reset password",
	"ResetPasswordConfirmation": "Confirm password reset",
	"ResetPasswordConfirmationMessagePart1": "Your password has been reset.",
	"ResetPasswordConfirmationMessagePart2": "Please click here to log in.",
	"ResetYourPassword": "Reset your password:",
	"FirstAccessSetPasswordConfirmation": "First access - Confirm password setting",
	"FirstAccessSetPasswordConfirmationMessagePart1": "This is your first login, your password has been set.",
	"FirstAccessSetPasswordConfirmationMessagePart2": "Click here to log in",
	"YourPasswordHasBeenChanged": "Your password has been changed",
	"AccountDisabled": "Account disabled",
	"Disabled": "Disabled",
	"ActiveUsers": "Active users",
	"AllUsers": "All users",
	"DeviceConnectionState": "Device connection state",
	"DeviceConnectionStateUpdatedTime": "Device connection state update",
	"DeviceConnectionString": "Device connection string",
	"DeviceLastActivityTime": "Device last activity time",
	"DeviceStatus": "Device status",
	"DeviceStatusUpdatedTime": "Device status update",
	"Code": "Code",
	"DisplayDescription": "Description",
	"DocType": "Doc type",
	"DocTypes": "Doc types",
	"NavigationMenuItemDocTypes": "Doc types",
	"CanAddUser": "Users Creation",
	"Email": "Email",
	"DisplayName": "Name",
	"DealerOfCustomer": "Customer dealer",
	"DeviceDetail": "Device details",
	"DeviceNotConfigured": "Device not configured on IoT Hub",
	"ManagePiles": "Piles management",
	"Pile": "Pile data",
	"PileStatusFinished": "Finished",
	"PileStatusPlanned": "Planned",
	"Piles": "WorkPlan piles",
	"PlanningDate": "Planning date",
	"ShortCode": "Short Code",
	"Status": "Status",
	"WorkPlanPiles": "WorkPlan piles",
	"WorkPlans": "WorkPlans",
	"SelectedMachines": "Selected machines",
	"SelectedMachinesEmpty": "Selected machines list is empty",
	"SelectedPiles": "Selected piles",
	"SelectedPilesEmpty": "Piles list is empty",
	"Send": "Send",
	"SendPilesTitle": "Machines to send the selected piles",
	"SendSelectedPiles": "Send selected piles",
	"Model": "Model",
	"Note": "Notes",
	"NotSpecified": "Not specified",
	"ProductionYear": "Production year",
	"ReferenceDate": "Reference date",
	"ErrorDescription": "Error description",
	"LastReception": "Last reception date",
	"LastSending": "Last sending date",
	"PileToMachineDetail": "Detail of sendings",
	"pileToMachineStatusError": "Error",
	"PileToMachineStatusReceived": "Received",
	"PileToMachineStatusSent": "Sent",
	"PileToMachineStatusToSend": "To send",
	"SendWorkPlan": "Send WorkPlan",
	"JobSite": "JobSite",
	"DeviceNotFoundException": "Device disconnected or not registered",
	"PileNameAlreadyExisting": "A pile with the name {0} already exists in the work plan",
	"ReSendWorkPlan": "ReSend WorkPlan",
	"NavigationMenuItemMachineFleet": "Machine Fleet",
	"ComingSoon": "Coming soon",
	"DirectCommand": "Commands",
	"Documentation": "Documentation",
	"InvokeLogRequest": "DataLog Request",
	"RemoteDesktop": "Remote Desktop",
	"GestioneNoleggi": "Rent Management",
	"Settings": "Set Point",
	"SpecialModeEnabled": "Enable Special Mode",
	"SyncInProgress": "Sync in progress",
	"Connected": "Connected",
	"Disconnected": "Disconnected",
	"MaintenanceLog": "Maintenance Log",
	"NoSending": "No sending done",
	"DownloadSelected": "Download selected",
	"DownloadWorkPlan": "Download WorkPlan",
	"InvokeLogRequestWasSentSuccessfully": "DataLog request was sent successfully",
	"ThereWasAnErrorOnCommandInvokeLogRequest": "Error on DataLog request",
	"CustomerManagerRole": "Customer Manager",
	"DealerManagerRole": "Dealer Manager",
	"ServiceManagerRole": "Service Manager",
	"Category": "Category",
	"MachineData": "Machine Data",
	"RequireCustomerAuthorization": "Required customer authorization",
	"TechData": "Technology Data",
	"InsertPin": "Insert PIN",
	"InvalidPin": "Invalid PIN",
	"Security": "Security",
	"UpdateSettingsFailed": "Update failed",
	"ChangePin": "Change PIN",
	"EditPin": "Edit PIN",
	"InvalidPinFormat": "Invalid PIN format (only 4-digit entry is allowed)",
	"NewPin": "New PIN",
	"UserNameAlreadyExists": "User name already exists",
	"Error": "Error",
	"User": "User",
	"RentRole": "Rent Manager",
	"IsRenter": "Rent Function",
	"IsRenterGrid": "Rent Function",
	"CustomerUser": "Hirer",
	"MachineRent": "Rent",
	"NavigationMenuItemMachineRent": "Rent",
	"CustomerRent": "Renter",
	"RentStatus": "Rent Status",
	"SiteData": "Site Data",
	"MachineHoursStart": "Initial Hours",
	"MachineHoursEnd": "Final Hours",
	"RentDays": "#Days",
	"MachineEffectiveHoursAveragePerDay": "Average",
	"RentExchangeStatusError": "Error",
	"RentExchangeStatusReceived": "Received",
	"RentExchangeStatusSent": "Sent",
	"RentExchangeStatusToSend": "To send",
	"RentStatusActive": "Active",
	"RentStatusTerminated": "Terminated",
	"RenterRole": "Rent Manager",
	"InvalidRenter": "Invalid Renter",
	"RentLog": "Rent Log",
	"CustomerWithSameName": "Customer already exists",
	"ShowAll": "Show All",
	"AlreadyExistsActiveRent": "An active rental already exists",
	"MaintenanceManagement": "Maintenance Management",
	"MaintenenceDate": "Maintenance Date",
	"TechnicianName": "Technician Name",
	"NextServiceDate": "Next Service Date",
	"MachineHours": "Total Machine Hours",
	"NavigationMenuItemMachineMaintenance": "Maintenance",
	"IsRentable": "Is Rentable",
	"Hide": "Hide Renter Customers",
	"HideHirer": "Hide Customer Principal",
	"Renter": "Owned by Renter",
	"RentAllowed": "Machine limited after rent",
	"DeviceRentAllowed": "Machine rent allowed",
	"RentAllowedSmall": "Limited Machine",
	"DeviceRentAllowedSmall": "Rent allowed",
	"OpenMap": "Open Map",
	"RefreshMap": "Refresh Map",
	"DataChangedByOtherUser": "The data was changed by another user. Please reload the page and try again.",
	"Map": "Map",
	"MaintenanceDate": "Maintenance Date",
	"MachineMaintenance": "Maintenance",
	"RentWrongDateSequence": "The rental start date must be earlier than or equal to the rental end date",
	"MachineNotFound": "Machine not found.",
	"MachineNotLinkedToDevice": "Machine not connected to any device. Rental is not possible.",
	"MachineDeviceNotRentable": "The device associated with the machine does not have the rental function.",
	"EqualTo": "Is equal to"
}}


// WEBPACK FOOTER //
// ./culture/SharedResources.ts